const SET_PROMO_CODE = (state, payload) => {
    state.promo_code = {};
    state.promo_code = payload;
}
const CLEAR_PROMO_CODE = (state) => {
    state.promo_code = '';
}
const SET_COUPON_ID = (state, payload) => {
    state.coupon_id = {};
    state.coupon_id = payload;
}
const CLEAR_COUPON_ID = (state) => {
    state.coupon_id = '';
}
const CLEAR_COUPON_STATE = (state) => {
    state.coupon_id = '';
    state.promo_code = '';
}

export { 
    SET_PROMO_CODE,
    CLEAR_PROMO_CODE,
    SET_COUPON_ID,
    CLEAR_COUPON_ID,
    CLEAR_COUPON_STATE
};